export default __webpack_public_path__ + "static/media/nft3a.decee5b5.png";